<template>
  <v-tooltip top :max-width="tooltipMaxWidth">
    <template v-slot:activator="{ on }">
      <div class="info-icon" v-on="on">
        <v-icon :color="infoIconColor" size="17.5">
          mdi-information
        </v-icon>
      </div>
    </template>
    {{ tooltip }}
  </v-tooltip>
</template>

<script>
export default {
  name: "ChartTitleTooltip",
  props: {
    tooltip: {
      type: String,
      required: true
    },
    tooltipMaxWidth: {
      type: Number,
      default: 500
    },
    infoIconColor: {
      type: String,
      default: "primary"
    }
  }
};
</script>

<style scoped lang="scss">
.info-icon {
  margin-left: $spacing * 0.5;
}
</style>
